module.exports = __webpack_public_path__ + "img/home-perfect-1.ad4b22c0.png";